var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.45,
    height: 15.767,
    viewBox: "0 0 16.45 15.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -19.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M410.828,104.137a1.023,1.023,0,0,1,.284.042l1.7-2.087a.313.313,0,0,1,.442-.046.305.305,0,0,1,.039.428l-1.684,2.065a.964.964,0,0,1-.388,1.445h6.606a.439.439,0,0,0,.439-.439V99.989a.439.439,0,0,0-.439-.439h-8.392a.439.439,0,0,0-.439.439v3.648l.4.5h1.431Z",
    transform: "translate(-401.82 -78.694)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.798,
    cy: 1.798,
    r: 1.798,
    transform: "translate(1.736 19.45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.377,268.207a.439.439,0,0,1-.439.439H4.2a.439.439,0,0,1-.439-.439v-3.68a.235.235,0,0,0-.235-.235h0a.235.235,0,0,0-.235.235v3.662a.458.458,0,0,1-.456.456H2.114a.439.439,0,0,1-.439-.439l0-8.883a.218.218,0,0,0-.218-.218h0a.218.218,0,0,0-.218.218v3.416a.439.439,0,0,1-.439.439H.439A.439.439,0,0,1,0,262.74v-4.684a1.006,1.006,0,0,1,1.006-1.006H5a1.408,1.408,0,0,1,1.1.532l1.074,1.355.226.286s1.018,0,1.6,0a.439.439,0,0,1,.439.439v.349a.439.439,0,0,1-.439.439H7.11a.611.611,0,0,1-.481-.233l-.8-1.029a.219.219,0,0,0-.172-.084H5.6a.218.218,0,0,0-.218.218Z",
    transform: "translate(0 -257.05)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutors);
export default __webpack_public_path__ + "static/media/tutors.030abcbcef6df9bdf5a9bccf78168dfd.svg";
export { ForwardRef as ReactComponent };